import { render } from "./UserBatchView.vue?vue&type=template&id=1703b00e"
import script from "./UserBatchView.vue?vue&type=script&lang=js"
export * from "./UserBatchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__